// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__gBFAC","tab":"ProcedureTabs_tab__3Ltn2"};